<template>
  <div class="page_wrapper container-fluid campus_recruiting_area">
    <div class="row page_header campus_recruiting_header">
      <campus-recruiting-header />
    </div>
    <div class="row campus_recruiting_content">
      <enterprise-authorized-booths-content />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import CampusRecruitingHeader from '~components/pages/campus-recruiting/common/CampusRecruitingHeader'
import EnterpriseAuthorizedBoothsContent from '~components/pages/campus-recruiting/enterprise/EnterpriseAuthorizedBoothsContent'
export default {
  name: 'EnterpriseAuthorizedBooths',
  middleware: ['check-auth', 'enterprise-auth'],
  routerName: 'Campus-recruiting:idEnterpriseAuthorized-booths',
  components: {
    CampusRecruitingHeader,
    EnterpriseAuthorizedBoothsContent
  },
  async created () {
    let id = this.$route.params.id;
    let status = await this.getCareerExpoBoothsStatus(id);
    if(status >= 3) {
        this.$router.push(`/campus-recruiting/${id}/enterprise?tab=報名紀錄`);
    }
  },
  methods: {
    ...mapActions('pages/enterprises', [
      'getCareerExpoBoothsStatus'
    ]),
  },
}
</script>
